module.exports = __webpack_public_path__ + "static/k-delights-3-622051d7de6a967b989ee26fb7a3b957.jpg";